import _ from 'underscore';
import jQuery from 'jquery';

export default class ListCategoriesProvider {
    constructor(conf, widget) {
        this.conf = _.extend({
            minLength: 3
        }, conf);
        this.widget = widget;
        this.providerName = 'ListCategoriesProvider';
        this.categoryList = this.normalizeList(widget.config.categories);
    }

    validate() {
        return true;
    }

    getPredictions(text) {
        if (typeof text !== 'string') {
            throw new Error('The text is missing');
        }
        let deferred = jQuery.Deferred();
        deferred.resolve(this.filterList(text));
        return deferred.promise();
    }

    normalizeList(list) {
        return list.map(cat => {
          return {
            code: cat.catId,
            catId: cat.catId,
            name: this.widget.polyglot.t(`categories.${cat.catId}`),
            value: this.widget.polyglot.t(`categories.${cat.catId}`),
            icon: cat.iconClass,
            provider: this.providerName
          }
        });
    }

    filterList(text) {
          return this.categoryList.filter(cat => {
              if(text.length >= this.conf.minLength){
                return cat.value.substr(0, text.length).toUpperCase() === text.toUpperCase();
              } else {
                  return false;
              }
          });
    }
}



// WEBPACK FOOTER //
// ./src/components/autocomplete/providers/ListCategoriesProvider.js